import { ReactNode, useState } from 'react';
import { Toggle, Dropdown } from '@ets/design-system';

type OptionsCellProps = {
  disabled?: boolean;
  items: ReactNode;
  testId: string;
  stopEventPropagation?: boolean;
};

const OptionsCell = ({
  disabled = false,
  items,
  testId,
  stopEventPropagation = false,
}: OptionsCellProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClickCapture = (e: React.MouseEvent<HTMLSpanElement>) => {
    setIsOpen(!isOpen);
    if (stopEventPropagation) {
      e.stopPropagation();
    }
  };

  return (
    <Dropdown.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dropdown.Trigger>
        <Toggle
          size="s"
          variant="link"
          isToggled={isOpen}
          iconProps={{ icon: 'ellipsis' }}
          disabled={disabled}
          testId={`${testId}-options`}
          onClickCapture={onClickCapture}
        />
      </Dropdown.Trigger>
      <Dropdown.Content align="end" testId={`${testId}-dropdown`}>
        {items}
      </Dropdown.Content>
    </Dropdown.Root>
  );
};

export default OptionsCell;
